import CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy from './CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy'

export default function CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy() {}

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype = new CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy();

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.init = function({timeFormat, showSpentTime, showAverageRates, showUserRates, showOthers}) {
    CostHTMLPreviewTwoLevelsHeaderBaseColumnsStrategy.prototype.init.call(
        this,
        {
            timeFormat,
            showSpentTime,
            showAverageRates,
            showOthers,
        }
    )
    this.showUserRates = showUserRates
    return this
}

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.isShowRatesForTopLevel = function () {
    return this.showUserRates;
};

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.getTopLevelNameKey = function () {
    return "report.user";
};

CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.prototype.getTopLevelHeaderCellClassName = function () {
    return this.showSpentTime ? "lightHeaderCell" : "lightGreenHeaderCell";
};


// WEBPACK FOOTER //
// ./web/js/reports/preview/html/cost/CostHTMLPreviewTwoLevelsHeaderUsersOnlyColumnsStrategy.js